var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmacies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.099,
    height: 42.103,
    viewBox: "0 0 35.099 42.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.045 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.045 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M326.556,4.339c5.347,0,9.064,5.135,8.435,10.212a8.671,8.671,0,0,1-8.48,7.492h-5.006v4.873h5.006A13.473,13.473,0,0,0,339.32,17.28a13.334,13.334,0,0,0,.452-5.418,13.646,13.646,0,0,0-.93-3.522A13.335,13.335,0,0,0,330.22.524a14.449,14.449,0,0,0-9.06.443,13.654,13.654,0,0,0-4.1,2.5,10.252,10.252,0,0,0-1.825,2.228h6.747A8.623,8.623,0,0,1,326.556,4.339Z",
    transform: "translate(-304.773 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.285,176.894v7.372c1.1.266,2.481.642,3.987,1.161v-8.533A13.315,13.315,0,0,0,105.5,165.211a1.327,1.327,0,0,0-1.32-1.471H80.374a1.325,1.325,0,0,0-1.32,1.471A13.31,13.31,0,0,0,90.285,176.894Z",
    transform: "translate(-79.045 -156.486)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M282.359,813.294a.665.665,0,0,0,.656-.775,4.646,4.646,0,0,0-1.706-2.875,5.264,5.264,0,0,0-.443-.31c-.142-.089-.292-.168-.443-.244v-.908a34.185,34.185,0,0,0-3.987-1.24v2.149a4.31,4.31,0,0,0-.443.244,4.4,4.4,0,0,0-.443.31,4.646,4.646,0,0,0-1.706,2.875.667.667,0,0,0,.656.775Z",
    transform: "translate(-265.205 -771.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.728,502.635v-4.9c-3.194.128-5.09,2.769-5.09,5.994a6.059,6.059,0,0,0,2.853,5.1,9.4,9.4,0,0,0,2.769.97h0a29.822,29.822,0,0,1,12.152,5.839,2.436,2.436,0,0,0,3.438-.261,2.249,2.249,0,0,0,.155-.2,2.4,2.4,0,0,0,.2-.359c.018-.04.035-.084.053-.124a2.586,2.586,0,0,0,.1-.3,2.435,2.435,0,0,0-.775-2.45,32.083,32.083,0,0,0-10.323-5.724c-1.161-.408-2.339-.767-3.531-1.068-.434-.111-.877-.221-1.316-.315C186.47,504.416,186.47,502.919,187.728,502.635Z",
    transform: "translate(-178.049 -475.689)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacies);
export default __webpack_public_path__ + "static/media/pharmacies.2f867fd99f30c20533c3ab6c80fa9a17.svg";
export { ForwardRef as ReactComponent };